import { PureComponent } from 'react';
import InitVisitFromId from '../components/InitVisitFromId';

import {
    NAVBAR_NAMES,
    NAV_BAR_ABHA_DASHBOARD,
    NAV_BAR_ADD_EKA_CREDITS,
    NAV_BAR_ANALYTICS,
    NAV_BAR_BOOK_TRAINING,
    NAV_BAR_CALENDAR,
    NAV_BAR_HE_DASHBOARD,
    NAV_BAR_HOME,
    NAV_BAR_IPD_LIST,
    NAV_BAR_KHATA,
    NAV_BAR_MY_GENIE,
    NAV_BAR_MY_RX_TEMPLATE,
    NAV_BAR_NEW_PATIENT,
    NAV_BAR_PATIENT,
    NAV_BAR_PATIENT_DETAILS,
    NAV_BAR_PATIENT_REFERRAL,
    NAV_BAR_PAYMENTS,
    NAV_BAR_PROFILE,
    NAV_BAR_SETTINGS,
    NAV_BAR_SUBSCRIBE,
} from '../components/common/NavBar';
import AllPatientsComponent from '../pages/AllPatients';
import Appointments from '../pages/Appointments';
import BorrowPrescription from '../pages/BorrowPrescription';
import FetchUpsertPrescription from '../pages/FetchUpsertPrescription';
import InitTool from '../pages/InitTool';
import Login from '../pages/Login';
import Logout from '../pages/Logout';
import NewPatient from '../pages/NewPatient';
import NotFound from '../pages/NotFound';
import PatientDetails from '../pages/PatientDetails';
import PaymentsDashboard from '../pages/PaymentsDashboard';
import RenderUserAgent from '../pages/RenderUserAgent';
import Settings from '../pages/Settings';
import SetupApp from '../pages/SetupApp';
// import VisitVideoCall from '../pages/VisitVideoCall';
import AnalyticsDasboard from '../pages/AnalyticsDashboard';
import BookTraining from '../pages/BookTraining';
import FlushAndSetup from '../pages/FlushAndSetup';
import HEDashboard from '../pages/HEDashboard';
import MyCalendar from '../pages/MyCalendar';
import MyGenie from '../pages/MyGenie';
import MyProfile from '../pages/MyProfile';
import MyRXTemplate from '../pages/MyRXTemplate';
import NewIpadAppAvailablePage from '../pages/NewIpadAppAvailablePage';
import NewQueue from '../pages/NewQueue';
import PrintPdf from '../pages/PrintPdf';
import ReceiptConfig from '../pages/ReceiptConfig';
import Subscribe from '../pages/Subscribe';
import HEOnboarding from '../pages/heOnboarding/HEOnboarding';
import PrescriptionPadV2 from '../pages/prescriptionPad/PrescriptionPadV2';
import TrialOrderHomePage from '../pages/trialOrder/TrialOrderHomePage';
import {
    GO_TO_ABHA_DASHBOARD,
    ALL_PATIENTS_ROUTE,
    GET_USER_AGENT,
    GO_TO_ADD_EKA_CREDITS,
    GO_TO_ADD_NEW_PATIENT,
    GO_TO_ANALYTICS_DASHBOARD,
    GO_TO_BOOK_TRAINING,
    GO_TO_BORROW_PRESCRIPTION_WITH_ID,
    GO_TO_CHANGE_DOC,
    GO_TO_FETCH_UPSERT_PRESCRIPTION_WITH_ID,
    GO_TO_FLUSH,
    GO_TO_HE_ONBOARDING,
    GO_TO_HE_TRIAL_ORDER,
    GO_TO_LOGIN,
    GO_TO_LOGOUT,
    GO_TO_MY_CALENDAR,
    GO_TO_MY_GENIE,
    GO_TO_MY_PROFILE,
    GO_TO_MY_RX_TEMPLATE,
    GO_TO_NEW_APPOINTMENT,
    GO_TO_OLD_APPOINTMENTS,
    GO_TO_PATIENTS_DETAILS,
    GO_TO_PATIENT_REFERRAL,
    GO_TO_PRINT_PDF,
    GO_TO_REDIRECT_IPAD,
    GO_TO_SETTINGS,
    GO_TO_SETUP_APP,
    GO_TO_SUBSCRIBE,
    GO_TO_VISIT_CALL_WITH_ID,
    HE_DASHBOARD_ROUTE,
    INIT,
    INIT_VISIT_WITH_FROM_ID,
    MY_KHATA_ROUTE,
    PAYMENT_DASHBOARD_ROUTE,
    PRESCRIPTION_PAD_V2_ROUTE,
    RECEIPT_CONFIG_ROUTE,
    REGISTER_ABDM,
    GO_TO_NEW_HXNG_FLOW,
    GO_TO_SCHEDULE,
    MR_PDF,
    IPD_LIST,
    GO_TO_CHANGE_GROUP,
    GO_TO_EKA_SCRIBESDK_DEMO,
} from './paths';
import ChangeDoc2 from '../pages/ChangeDoc2';
import MyKhata from '../pages/MyKhata';
import AddEkaCredits from '../pages/AddEkaCredits';
import ABHADashboard from '../pages/ABHADashboard';
import RegisterABDM from '../pages/RegisterABDM';
import PatientReferralDashboard from '../pages/PatientReferralDashboard';
import NewHXNGFlow from '../pages/NewHXNGFlow';
import SchedulePage from '../pages/schedule/SchedulePage';
import { MrPdf } from '../components/prescriptionPad/MedicalRecordsComponent';
import IpdList from '../components/IPD/IpdList';
import ChangeGroup from '../pages/ChangeGroup';
import EkaScribeWithSDKDemo from '../components/EkaScribeWithSDKDemo';

export interface AppRoute {
    key?: 'padV1' | 'padV2' | 'padV3' | 'borrow';
    path: string;
    component: typeof PureComponent;
    exact?: boolean;
    isOutApp?: boolean;
    title?: string;
    pageTrackingName?: string;
    navBarName?: NAVBAR_NAMES;
    tabName?: 'Appointments' | 'AllPatients';
}

const routes: AppRoute[] = [
    // {
    //     path: GO_TO_GMB_DASHBOARD,
    //     exact: true,
    //     // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //     // @ts-ignore
    //     component: GMB,
    //     navBarName: NAV_BAR_GMB,
    //     pageTrackingName: 'GO_TO_GMB_DASHBOARD',
    // },
    {
        path: INIT_VISIT_WITH_FROM_ID,
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: InitVisitFromId,
        pageTrackingName: 'Init_Visit_From_Id',
    },
    {
        // TODO needs to deleted, if not used
        path: GO_TO_PRINT_PDF(':fileName'),
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: PrintPdf,
        pageTrackingName: 'Print_page',
    },
    {
        path: INIT,
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: InitTool,
        pageTrackingName: 'Init_page',
    },
    {
        path: GO_TO_CHANGE_DOC,
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: ChangeDoc2,
        pageTrackingName: 'Change_Doc',
    },
    {
        path: GO_TO_CHANGE_GROUP,
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: ChangeGroup,
        pageTrackingName: 'Change_Group',
    },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    { path: GET_USER_AGENT, exact: true, component: RenderUserAgent },
    {
        path: PAYMENT_DASHBOARD_ROUTE,
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: PaymentsDashboard,
        pageTrackingName: 'Payments_Dashboard',
        navBarName: NAV_BAR_PAYMENTS,
    },
    {
        path: RECEIPT_CONFIG_ROUTE,
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: ReceiptConfig,
        pageTrackingName: 'Receipt_Config',
        navBarName: NAV_BAR_PAYMENTS,
    },
    {
        path: GO_TO_HE_TRIAL_ORDER(':type', ':state'),
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: TrialOrderHomePage,
        pageTrackingName: 'Trial_Order',
    },
    {
        path: HE_DASHBOARD_ROUTE,
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: HEDashboard,
        pageTrackingName: 'HE_Dashboard',
        navBarName: NAV_BAR_HE_DASHBOARD,
    },
    {
        path: MY_KHATA_ROUTE,
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: MyKhata,
        pageTrackingName: 'My_Khata',
        navBarName: NAV_BAR_KHATA,
    },
    {
        path: GO_TO_ABHA_DASHBOARD,
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: ABHADashboard,
        pageTrackingName: 'ABHA_Dashboard',
        navBarName: NAV_BAR_ABHA_DASHBOARD,
    },
    {
        path: GO_TO_NEW_HXNG_FLOW,
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: NewHXNGFlow,
        pageTrackingName: 'New_HXNG_Flow',
        navBarName: NAV_BAR_HE_DASHBOARD,
    },
    {
        path: GO_TO_EKA_SCRIBESDK_DEMO,
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: EkaScribeWithSDKDemo,
        pageTrackingName: 'ekaScribeDemoOnDR',
    },
    {
        path: GO_TO_HE_ONBOARDING(''),
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: HEOnboarding,
        pageTrackingName: 'HE_Onboarding',
        navBarName: NAV_BAR_HE_DASHBOARD,
    },
    {
        path: GO_TO_HE_ONBOARDING(':state'),
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: HEOnboarding,
        pageTrackingName: 'HE_Onboarding',
        navBarName: NAV_BAR_HE_DASHBOARD,
    },
    {
        path: GO_TO_ANALYTICS_DASHBOARD(),
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: AnalyticsDasboard,
        pageTrackingName: 'Analytics_Dashboard',
        navBarName: NAV_BAR_ANALYTICS,
    },
    {
        path: GO_TO_SETTINGS(':subRoute'),
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: Settings,
        pageTrackingName: 'Settings',
        navBarName: NAV_BAR_SETTINGS,
    },
    {
        path: GO_TO_SUBSCRIBE,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: Subscribe,
        pageTrackingName: 'Subscribe',
        navBarName: NAV_BAR_SUBSCRIBE,
    },
    {
        path: GO_TO_ADD_EKA_CREDITS,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: AddEkaCredits,
        pageTrackingName: 'Add_Eka_Credits',
        navBarName: NAV_BAR_ADD_EKA_CREDITS,
    },
    {
        path: GO_TO_BOOK_TRAINING,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: BookTraining,
        pageTrackingName: 'Book_Training',
        navBarName: NAV_BAR_BOOK_TRAINING,
    },
    {
        path: GO_TO_MY_RX_TEMPLATE,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: MyRXTemplate,
        pageTrackingName: 'Edit_Template',
        navBarName: NAV_BAR_MY_RX_TEMPLATE,
    },
    {
        path: GO_TO_MY_PROFILE,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: MyProfile,
        pageTrackingName: 'MyProfile',
        navBarName: NAV_BAR_PROFILE,
    },
    {
        path: GO_TO_MY_GENIE(':subRoute'),
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: MyGenie,
        pageTrackingName: 'MyGenie',
        navBarName: NAV_BAR_MY_GENIE,
    },
    {
        path: GO_TO_PATIENT_REFERRAL,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: PatientReferralDashboard,
        pageTrackingName: 'MyPatientRefer',
        navBarName: NAV_BAR_PATIENT_REFERRAL,
    },
    {
        path: GO_TO_MY_CALENDAR,
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: MyCalendar,
        pageTrackingName: 'My_Calendar',
        navBarName: NAV_BAR_CALENDAR,
    },
    {
        path: GO_TO_NEW_APPOINTMENT(':cId'),
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: NewQueue,
        pageTrackingName: 'Home',
        navBarName: NAV_BAR_HOME,
        tabName: 'Appointments',
    },
    {
        path: GO_TO_SCHEDULE(':cId?'),
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: SchedulePage,
        pageTrackingName: 'Schedule',
        tabName: 'Appointments',
    },
    {
        path: GO_TO_OLD_APPOINTMENTS(':cId?', ':section?'),
        // exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: Appointments,
        pageTrackingName: 'Home_Appointments',
        navBarName: NAV_BAR_HOME,
        tabName: 'Appointments',
    },
    {
        path: ALL_PATIENTS_ROUTE,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: AllPatientsComponent,
        exact: true,
        pageTrackingName: 'Home_All_Patients',
        navBarName: NAV_BAR_PATIENT,
        tabName: 'AllPatients',
    },
    {
        path: GO_TO_ADD_NEW_PATIENT(':cId'),
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: NewPatient,
        exact: true,
        pageTrackingName: 'Add_Patient',
        navBarName: NAV_BAR_NEW_PATIENT,
    },
    {
        path: GO_TO_ADD_NEW_PATIENT(''),
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: NewPatient,
        exact: true,
        pageTrackingName: 'Add_Patient',
        navBarName: NAV_BAR_NEW_PATIENT,
    },
    {
        key: 'padV2',
        path: PRESCRIPTION_PAD_V2_ROUTE,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: PrescriptionPadV2,
        exact: true,
        pageTrackingName: 'Prescription_Pad_V2',
        navBarName: NAV_BAR_HOME,
    },
    // {
    //     path: GO_TO_VISIT_CALL_WITH_ID(':vId'),
    //     // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //     // @ts-ignore
    //     component: VisitVideoCall,
    //     exact: true,
    //     pageTrackingName: 'Video_Call',
    // },
    {
        key: 'borrow',
        path: GO_TO_BORROW_PRESCRIPTION_WITH_ID(':plId', ':pxId'),
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: BorrowPrescription,
        pageTrackingName: 'Borrow_Prescription',
    },
    {
        path: GO_TO_FETCH_UPSERT_PRESCRIPTION_WITH_ID(':pxId'),
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: FetchUpsertPrescription,
        pageTrackingName: 'Fetch_Upsert_Prescription',
    },
    {
        path: GO_TO_LOGIN,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: Login,
        title: 'Login',
        pageTrackingName: 'Login',
    },
    {
        path: GO_TO_PATIENTS_DETAILS(':plId', ':subRoute', ':subRouteParam?'),
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: PatientDetails,
        exact: true,
        pageTrackingName: 'Patient_Details',
        navBarName: NAV_BAR_PATIENT_DETAILS,
    },
    {
        path: GO_TO_SETUP_APP,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: SetupApp,
        pageTrackingName: 'Setup_App',
    },
    {
        path: GO_TO_LOGOUT,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: Logout,
        pageTrackingName: 'Logout',
    },
    {
        path: GO_TO_FLUSH,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: FlushAndSetup,
        pageTrackingName: 'Flush',
    },
    {
        path: GO_TO_REDIRECT_IPAD,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: NewIpadAppAvailablePage,
        pageTrackingName: 'New_Ipad_App_Available',
    },
    {
        path: REGISTER_ABDM,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: RegisterABDM,
        pageTrackingName: 'RegisterABDM',
    },
    {
        path: MR_PDF,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: MrPdf,
        pageTrackingName: 'MrPdf',
    },
    {
        path: IPD_LIST,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: IpdList,
        pageTrackingName: 'IpdList',
        navBarName: NAV_BAR_IPD_LIST,
    },
    {
        path: '*',
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: NotFound,
        pageTrackingName: 'Not_Found',
    },
];

export default routes;
